import React, { useState, useEffect, useRef } from 'react';
import './passengerSocialProfile.css';
import {
  FaImage,
  FaVideo,
  FaShare,
  FaHome,
  FaUser,
  FaArrowLeft,
  FaChartBar,
  FaHistory,
  FaTimes
} from 'react-icons/fa';
import { MdExplore } from "react-icons/md";
import { BsFillPlayCircleFill } from "react-icons/bs";
import { ref, onValue, push, set, remove, get } from 'firebase/database';
import {
  getStorage,
  ref as sRef,
  uploadBytesResumable,
  getDownloadURL
} from 'firebase/storage';

import { db, auth } from '../firebase';
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../utils/formatCurrency";
import imageCompression from "browser-image-compression";

const PassengerSocialProfile = ({ passengerProfile, onClose }) => {
  const currentUser = auth.currentUser;

  const { t, i18n } = useTranslation();

const userCountry =
  passengerProfile?.country ||
  localStorage.getItem("country") ||
  "Papua New Guinea";

  const viewedUid = passengerProfile?.uid || currentUser?.uid || null;
  const profilePic =
    passengerProfile?.photoUrl ||
    passengerProfile?.photoURL ||
    "/default-avatar.png";
  const userName = passengerProfile?.name || "Passenger";
const [walletData, setWalletData] = useState({
  balance: 0,
  totalSaved: 0,
  totalWithdrawn: 0,
  updatedAt: 0,
});

const [walletTransactions, setWalletTransactions] = useState([]);
const [withdrawAmount, setWithdrawAmount] = useState("");
const [withdrawMethod, setWithdrawMethod] = useState("BSP Mobile");
const [accountNumber, setAccountNumber] = useState("");
const [withdrawing, setWithdrawing] = useState(false);
  const [posts, setPosts] = useState([]);
  const [myRides, setMyRides] = useState([]);
  const [postText, setPostText] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [activeView, setActiveView] = useState('feed');
  const [postFilter, setPostFilter] = useState('all');
  const [isSharing, setIsSharing] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
const [replyInputs, setReplyInputs] = useState({});
  const imageInputRef = useRef(null);
  const videoInputRef = useRef(null);
const [selectedWalletRide, setSelectedWalletRide] = useState(null);
const [historyPeriod, setHistoryPeriod] = useState("weekly");
const [selectedGraphRides, setSelectedGraphRides] = useState([]);
const [showGraphDetails, setShowGraphDetails] = useState(false);

const generateHistoryData = () => {
  const now = new Date();

  let grouped = {};

  myRides.forEach((ride) => {
    const date = new Date(ride.timestamp || ride.date);

    let key = "";

    if (historyPeriod === "daily") {
      key = date.toLocaleDateString();
    }

    if (historyPeriod === "weekly") {
      key = `Week ${Math.ceil(date.getDate() / 7)}`;
    }

    if (historyPeriod === "monthly") {
      key = date.toLocaleString("default", {
        month: "short",
      });
    }

    if (historyPeriod === "yearly") {
      key = date.getFullYear().toString();
    }

    if (!grouped[key]) {
      grouped[key] = {
        total: 0,
        rides: [],
      };
    }

    grouped[key].total += Number(ride.fare || 0);

    grouped[key].rides.push(ride);
  });

  return Object.entries(grouped).map(([label, data]) => ({
    label,
    total: data.total,
    rides: data.rides,
  }));
};

const historyGraphData = generateHistoryData();

const maxGraphValue =
  Math.max(...historyGraphData.map((g) => g.total), 1);


  const toDayKey = (value) => {
    if (!value) return null;

    let d;

    if (typeof value === "number") {
      d = new Date(value);
    } else if (value instanceof Date) {
      d = value;
    } else if (typeof value === "object" && value.seconds) {
      d = new Date(value.seconds * 1000);
    } else if (typeof value === "string") {
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
      d = new Date(value);
      if (isNaN(d.getTime())) return null;
    } else {
      return null;
    }

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDisplayDate = (value) => {
    const key = toDayKey(value);
    if (!key) return "";
    const d = new Date(key);
    return d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const timeAgo = (t) => {
    if (!t) return "";
    const s = Math.floor((Date.now() - t) / 1000);
    if (s < 60) return "Just now";
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
  };

  useEffect(() => {
    if (!currentUser || !viewedUid) return;

    const postsRef = ref(db, 'social_posts');
    const unsubPosts = onValue(postsRef, (snap) => {
      if (snap.exists()) {
        const postsArray = Object.entries(snap.val())
          .map(([id, val]) => ({ id, ...val }))
.filter((post) => post.wallOwnerId === viewedUid)          
          .sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

        setPosts(postsArray);
      } else {
        setPosts([]);
      }
    });

    const ridesRef = ref(db, 'rides');
    const unsubRides = onValue(ridesRef, async (snap) => {
      if (snap.exists()) {
        const data = snap.val();

        const rideList = Object.entries(data)
          .map(([id, val]) => ({ id, ...val }))
          .filter(
            (r) =>
              r.passengerId === viewedUid &&
              (
                r.status === 'accepted' ||
                r.status === 'completed' ||
                r.tripEnded === true
              )
          );

        const enrichedRides = await Promise.all(
          rideList.map(async (ride) => {
           let dPhoto = "/default-avatar.png";
let dName = "Driver";
let dPhone = "";

            if (ride.driverId) {
              try {
                const dSnap = await get(ref(db, `drivers/${ride.driverId}`));
                if (dSnap.exists()) {
                  const dData = dSnap.val();
                  dPhoto = dData.photoURL || dData.photoUrl || dPhoto;
                  dName = dData.name || dName;
                  dPhone =
  dData.phone ||
  dData.phoneNumber ||
  dData.mobile ||
  "";
                }
              } catch (err) {
                console.error("Driver fetch error:", err);
              }
            }

if (
  ride.passengerId &&
  (ride.status === "completed" || ride.tripEnded === true) &&
  !ride.walletRewarded
) {
  try {
    const fareAmount = Number(ride.fare || 0);
    const savingsAmount = fareAmount * 0.10;

    const walletRef = ref(db, `wallets/${ride.passengerId}`);
    const walletSnap = await get(walletRef);

    const currentWallet = walletSnap.exists()
      ? walletSnap.val()
      : {
          balance: 0,
          totalSaved: 0,
          totalWithdrawn: 0,
        };

    await set(walletRef, {
      balance:
        Number(currentWallet.balance || 0) + savingsAmount,

      totalSaved:
        Number(currentWallet.totalSaved || 0) + savingsAmount,

      totalWithdrawn:
        Number(currentWallet.totalWithdrawn || 0),

      updatedAt: Date.now(),
    });

    const txRef = push(
      ref(db, `walletTransactions/${ride.passengerId}`)
    );

    await set(txRef, {
      type: "ride_savings",
      amount: savingsAmount,
      fare: fareAmount,
      rideId: ride.id,
      status: "completed",
      createdAt: Date.now(),
      note: "10% ride savings reward",
    });

    await set(
      ref(db, `rides/${ride.id}/walletRewarded`),
      true
    );

  } catch (err) {
    console.error("Wallet reward error:", err);
  }
}

return {
  ...ride,
  driverPhoto: dPhoto,
  driverName: dName,
  driverPhone: dPhone,
};            
          })
        );

        enrichedRides.sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));
        setMyRides(enrichedRides);
      } else {
        setMyRides([]);
      }
    });

    return () => {
      unsubPosts();
      unsubRides();
    };
  }, [currentUser, viewedUid]);

  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

const [commentInputs, setCommentInputs] = useState({});

  const now = new Date();
  const todayDayIndex = now.getDay();
  const monday = new Date(now);
  monday.setDate(now.getDate() - ((todayDayIndex + 6) % 7));
  monday.setHours(0, 0, 0, 0);

  const weeklyBreakdown = [...Array(7)].map((_, i) => {
    const d = new Date(monday);
    d.setDate(monday.getDate() + i);

    const dayKey = toDayKey(d);
    const dayName = d.toLocaleDateString("en-US", { weekday: "long" });

    const dayTotal = myRides
      .filter((r) => {
        const rideDayKey = toDayKey(r.date) || toDayKey(r.timestamp);
        return rideDayKey === dayKey;
      })
      .reduce((sum, r) => sum + (Number(r.fare) || 0), 0);

    return {
      day: dayName,
      date: formatDisplayDate(d),
      amount: dayTotal,
      savings: dayTotal * 0.10,
    };
  });

const totalSpend = myRides.reduce((sum, r) => sum + (Number(r.fare) || 0), 0);
const walletBalance = Number(walletData.balance || 0);
const totalSavings = Number(walletData.totalSaved || 0);
const withdrawalThreshold = 100;

const pendingWithdrawalTotal = walletTransactions
  .filter(tx => tx.type === "withdrawal" && tx.status === "pending")
  .reduce((sum, tx) => sum + Number(tx.amount || 0), 0);

const availableBalance = Math.max(0, walletBalance - pendingWithdrawalTotal);
const canWithdraw = availableBalance >= withdrawalThreshold;
const amountLeftToWithdraw = Math.max(0, withdrawalThreshold - availableBalance);

  const handleImagePick = () => {
    imageInputRef.current?.click();
  };

  const handleVideoPick = () => {
    videoInputRef.current?.click();
  };

  const handleFileSelect = (e, forcedType) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validImage = forcedType === 'image' && file.type.startsWith('image/');
    const validVideo = forcedType === 'video' && file.type.startsWith('video/');

    if (!validImage && !validVideo) {
      alert(forcedType === 'image' ? "Please choose an image file only." : "Please choose a video file only.");
      return;
    }
const MAX_IMAGE_SIZE =
  10 * 1024 * 1024;

if (
  forcedType === "image" &&
  file.size > MAX_IMAGE_SIZE
) {

  alert(
    `Image too large.

Maximum:
10MB

Selected:
${(
  file.size /
  1024 /
  1024
).toFixed(2)}MB`
  );

  return;
}

    if (previewUrl) URL.revokeObjectURL(previewUrl);

    setSelectedFile(file);
    setMediaType(forcedType);
setPreviewUrl(
  URL.createObjectURL(file)
);    
    setActiveView('feed');
  };

  const clearSelectedMedia = () => {
    if (previewUrl) URL.revokeObjectURL(previewUrl);
    setSelectedFile(null);
    setMediaType(null);
    setPreviewUrl("");

    if (imageInputRef.current) imageInputRef.current.value = "";
    if (videoInputRef.current) videoInputRef.current.value = "";
  };

const handleCreatePost = async () => {
  if (!postText.trim() && !selectedFile) return;
  if (!currentUser || !viewedUid) return;

  setUploading(true);

  try {
    let mediaUrl = null;

    if (selectedFile) {
let uploadFile = selectedFile;

if (
  mediaType === "image"
) {

if (selectedFile.size > 20 * 1024 * 1024) {
  alert("Please choose a smaller image.");
  setUploading(false);
  return;
}

try {

  console.log(
    "Original image:",
    selectedFile.size / 1024 / 1024,
    "MB"
  );

  uploadFile =
    await imageCompression(
      selectedFile,
      {
        maxSizeMB: 0.8,
        maxWidthOrHeight: 1080,
        useWebWorker: true,
        initialQuality: 0.6,
        alwaysKeepResolution: false,
      }
    );

  console.log(
    "Compressed image:",
    uploadFile.size / 1024 / 1024,
    "MB"
  );

} catch (compressionError) {

  console.warn(
    "Compression skipped:",
    compressionError
  );

  uploadFile = selectedFile;
}

}

const storage = getStorage();
      const fileRef = sRef(
        storage,
        `social_media/${currentUser.uid}/${Date.now()}_${selectedFile.name}`
      );
    
    
    
 const uploadTask = uploadBytesResumable(
  fileRef,
  uploadFile
);

await new Promise((resolve, reject) => {

  uploadTask.on(
    "state_changed",

    (snapshot) => {

      const progress =
        (
          snapshot.bytesTransferred /
          snapshot.totalBytes
        ) * 100;

      console.log(
        "Upload progress:",
        progress
      );

    },

    (error) => {

      console.error(
        "Upload failed:",
        error
      );

      alert(
        "Image upload failed."
      );

      reject(error);

    },

    async () => {

      mediaUrl =
        await getDownloadURL(
          uploadTask.snapshot.ref
        );

      resolve();

    }
  );

});

    }

    await set(push(ref(db, "social_posts")), {
      wallOwnerId: viewedUid,
      wallOwnerRole: "passenger",

      authorId: currentUser.uid,

authorName:
  passengerProfile?.name ||
  currentUser.displayName ||
  localStorage.getItem("name") ||
  "User",

authorPhoto:
  passengerProfile?.photoUrl ||
  passengerProfile?.photoURL ||
  currentUser.photoURL ||
  localStorage.getItem("photoURL") ||
  profilePic ||
  "/default-avatar.png",
authorRole:
  localStorage.getItem("role") || "passenger", 

      text: postText.trim(),
      mediaUrl,
      mediaType,
      timestamp: Date.now(),
      likes: {},
    });

    setPostText("");
    clearSelectedMedia();
  } catch (error) {
    console.error(error);
    alert("Post failed.");
  } finally {
    setUploading(false);
  }
};

useEffect(() => {
  if (!currentUser || !viewedUid) return;

  const walletRef = ref(db, `wallets/${viewedUid}`);
  const txRef = ref(db, `walletTransactions/${viewedUid}`);

  const unsubWallet = onValue(walletRef, (snap) => {
    if (snap.exists()) {
      setWalletData(snap.val());
    } else {
      setWalletData({
        balance: 0,
        totalSaved: 0,
        totalWithdrawn: 0,
        updatedAt: 0,
      });
    }
  });

  const unsubTx = onValue(txRef, (snap) => {
    if (snap.exists()) {
      const txs = Object.entries(snap.val())
        .map(([id, val]) => ({ id, ...val }))
        .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
      setWalletTransactions(txs);
    } else {
      setWalletTransactions([]);
    }
  });

  return () => {
    unsubWallet();
    unsubTx();
  };
}, [currentUser, viewedUid]);

  const handleToggleLike = async (postId, currentLikes) => {
    if (!currentUser) return;

    const hasLiked = currentLikes && currentLikes[currentUser.uid];
    const likeRef = ref(db, `social_posts/${postId}/likes/${currentUser.uid}`);

    try {
      if (hasLiked) {
        await remove(likeRef);
      } else {
        await set(likeRef, true);
      }
    } catch (err) {
      console.error(err);
    }
  };

const handleAddComment = async (postId) => {
  if (!currentUser) return;

  const text = (commentInputs[postId] || "").trim();
  if (!text) return;

  try {
    const commentRef = push(ref(db, `social_posts/${postId}/comments`));

    await set(commentRef, {
      userId: currentUser.uid,
      userName:
        currentUser.displayName ||
        localStorage.getItem("name") ||
        "User",
      userPhoto:
  passengerProfile?.photoUrl ||
  passengerProfile?.photoURL ||
  currentUser.photoURL ||
  localStorage.getItem("photoURL") ||
  profilePic ||
  "/default-avatar.png",
      text,
      timestamp: Date.now(),
      role: localStorage.getItem("role") || "passenger",
    });

    setCommentInputs((prev) => ({
      ...prev,
      [postId]: "",
    }));
  } catch (err) {
    console.error("Failed to add comment:", err);
    alert("Failed to add comment.");
  }
};

const handleAddReply = async (postId, commentId) => {
  if (!currentUser) return;

  const text = (replyInputs[`${postId}_${commentId}`] || "").trim();
  if (!text) return;

  try {
    const replyRef = push(
      ref(db, `social_posts/${postId}/comments/${commentId}/replies`)
    );

    await set(replyRef, {
      userId: currentUser.uid,
      userName:
  currentUser.displayName ||
  localStorage.getItem("name") ||
  "User",
userPhoto:
  currentUser.photoURL ||
  localStorage.getItem("photoURL") ||
  "/default-avatar.png",
      text,
      timestamp: Date.now(),
role: localStorage.getItem("role") || "passenger",      
    });

    setReplyInputs((prev) => ({
      ...prev,
      [`${postId}_${commentId}`]: "",
    }));
  } catch (err) {
    console.error("Failed to add reply:", err);
    alert("Failed to send reply.");
  }
};

const handleReactToComment = async (postId, commentId, emoji) => {
  if (!currentUser) return;

  const reactionRef = ref(
    db,
    `social_posts/${postId}/comments/${commentId}/reactions/${currentUser.uid}`
  );

  try {
    const snap = await get(reactionRef);

    if (snap.exists() && snap.val()?.value === emoji) {
      await remove(reactionRef);
    } else {
      await set(reactionRef, {
        value: emoji,
        userId: currentUser.uid,
userName:
  currentUser.displayName ||
  localStorage.getItem("name") ||
  "User",        
role: localStorage.getItem("role") || "passenger",        
        reactedAt: Date.now(),
      });
    }
  } catch (err) {
    console.error("Comment reaction failed:", err);
  }
};

const handleReactToReply = async (postId, commentId, replyId, emoji) => {
  if (!currentUser) return;

  const reactionRef = ref(
    db,
    `social_posts/${postId}/comments/${commentId}/replies/${replyId}/reactions/${currentUser.uid}`
  );

  try {
    const snap = await get(reactionRef);

    if (snap.exists() && snap.val()?.value === emoji) {
      await remove(reactionRef);
    } else {
      await set(reactionRef, {
        value: emoji,
        userId: currentUser.uid,
userName:
  currentUser.displayName ||
  localStorage.getItem("name") ||
  "User",        
role: localStorage.getItem("role") || "passenger",        
        reactedAt: Date.now(),
      });
    }
  } catch (err) {
    console.error("Reply reaction failed:", err);
  }
};

const handleWithdrawRequest = async () => {
  const amount = Number(withdrawAmount);

  if (!currentUser) return alert("Please log in.");
  if (!amount || amount <= 0) return alert("Enter a valid amount.");
  if (amount < 100) return alert("Minimum withdrawal is K100.00");
const pendingWithdrawalTotal = walletTransactions
  .filter(tx => tx.type === "withdrawal" && tx.status === "pending")
  .reduce((sum, tx) => sum + Number(tx.amount || 0), 0);

const availableBalance = Number(walletData.balance || 0) - pendingWithdrawalTotal;

if (amount > availableBalance) {
  return alert("Insufficient available balance.");
}
  if (!withdrawMethod.trim()) return alert("Select withdrawal method.");
  if (!accountNumber.trim()) return alert("Enter account or phone number.");

  setWithdrawing(true);

  try {
    const requestRef = push(ref(db, "withdrawRequests"));

    await set(requestRef, {
      passengerId: currentUser.uid,
      passengerName: passengerProfile?.name || "Passenger",
      amount,
      method: withdrawMethod,
      accountNumber,
      status: "pending",
      createdAt: Date.now(),
    });

    const txRef = push(ref(db, `walletTransactions/${currentUser.uid}`));
    await set(txRef, {
      type: "withdrawal",
      amount,
      status: "pending",
      createdAt: Date.now(),
      note: `Withdrawal request via ${withdrawMethod}`,
      accountNumber,
    });

    alert("Withdrawal request submitted successfully.");
    setWithdrawAmount("");
    setAccountNumber("");
  } catch (err) {
    console.error(err);
    alert("Failed to submit withdrawal request.");
  } finally {
    setWithdrawing(false);
  }
};

  const handleSharePost = async (post) => {
    if (isSharing || !navigator.share) return;

    setIsSharing(true);
    try {
      await navigator.share({
        title: "KinaHub Post",
        text: post.text || "Check out my KinaHub update",
        url: post.mediaUrl || window.location.href,
      });
    } catch (err) {
      console.log(err);
    } finally {
      setTimeout(() => setIsSharing(false), 500);
    }
  };

  const filteredPosts = posts.filter((p) => {
    if (postFilter === 'image') return p.mediaType === 'image';
    if (postFilter === 'video') return p.mediaType === 'video';
    return true;
  });
if (!currentUser) {
  return (
    <div className="social-profile-overlay">
      <div className="social-container">
        <div className="social-card">Please log in to open your profile.</div>
      </div>
    </div>
  );
}

if (!viewedUid) {
  return (
    <div className="social-profile-overlay">
      <div className="social-container">
        <div className="social-card">Profile data not found.</div>
      </div>
    </div>
  );
}

return (
  <div className="social-profile-overlay">
    <input
  type="file"
accept="image/jpeg,image/jpg,image/png,image/webp"

      ref={imageInputRef}
      style={{ display: 'none' }}
      onChange={(e) => handleFileSelect(e, 'image')}
    />

    <input
      type="file"
      accept="video/*"
      ref={videoInputRef}
      style={{ display: 'none' }}
      onChange={(e) => handleFileSelect(e, 'video')}
    />

    <div className="social-top-nav">
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <FaArrowLeft size={16} onClick={onClose} style={{ cursor: "pointer" }} />
        <div className="social-logo">🚀 KinaHub</div>
      </div>

      <div className="social-nav-links">
        <div
          className="social-nav-item"
          onClick={() => {
            setActiveView('feed');
            setPostFilter('all');
          }}
          style={{ color: activeView === 'feed' ? '#ff416c' : undefined }}
        >
          <MdExplore size={14} /> {t("feed")}
        </div>

        <div
          className="social-nav-item"
          onClick={() => setActiveView('history')}
          style={{ color: activeView === 'history' ? '#ff416c' : undefined }}
        >
          <FaHistory size={13} /> {t("history")}
        </div>

        <div
          className="social-nav-item"
          onClick={() => setActiveView('wallet')}
          style={{ color: activeView === 'wallet' ? '#ff416c' : undefined }}
        >
          💰 {t("wallet")}
        </div>

        <div className="social-nav-profile">
          <img src={profilePic} alt="" />
        </div>
      </div>
    </div>

    <div className="social-container">
      {activeView === 'feed' && (
        <div className="social-card">
          <h4 style={{ marginBottom: '10px', fontSize: '13px', color: "#18508a" }}>
            {t("recent_drivers")}

          </h4>

          <div style={{ display: "flex", overflowX: "auto", gap: "10px" }}>
            {myRides.length === 0 ? (
              <div style={{ fontSize: '12px', color: '#777' }}>{t("no_recent_drivers")}</div>
            ) : (
              myRides.slice(0, 10).map((ride) => (
                <div key={ride.id} style={{ textAlign: "center", flexShrink: 0 }}>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      border: ride.status === 'completed' || ride.tripEnded === true
                        ? "2px solid #00c853"
                        : "2px solid #ff9800",
                      padding: '2px'
                    }}
                  >
                    <img
                      src={ride.driverPhoto}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "50%",
                        objectFit: "cover"
                      }}
                      alt=""
                    />
                  </div>
                  <small style={{ fontSize: "9px", display: "block", marginTop: "2px" }}>
                    {ride.driverName?.split(' ')[0]}
                  </small>
                </div>
              ))
            )}
          </div>
        </div>
      )}

        {activeView === 'feed' && (
          <>
            <div className="social-card">
              <div className="create-post-header">{t("create_post")}</div>

              <div className="create-post-input-area">
                <img src={profilePic} alt="" />
                <input
                  type="text"
placeholder={t("write_caption")}                  
                  value={postText}
                  onChange={(e) => setPostText(e.target.value)}
                />
              </div>

              {selectedFile && (
                <div style={{ marginBottom: '12px', position: 'relative' }}>
                  <div
                    onClick={clearSelectedMedia}
                    style={{
                      position: 'absolute',
                      top: '8px',
                      right: '8px',
                      zIndex: 2,
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fff',
                      width: '28px',
                      height: '28px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer'
                    }}
                  >
                    <FaTimes size={12} />
                  </div>

                  {mediaType === 'image' ? (
                    <img
                      src={previewUrl}
                      alt="preview"
                      className="post-single-image"
                    />
                  ) : (
                    <video
                      src={previewUrl}
                      controls
                      className="post-single-image"
                    />
                  )}
                </div>
              )}

              <div className="create-post-actions">
                <button className="post-action-btn btn-image" onClick={handleImagePick}>
                  <FaImage /> {t("pics")}
                </button>

                <button className="post-action-btn btn-video" onClick={handleVideoPick}>
                  <FaVideo /> {t("videos")}
                </button>

                <button
                  className="post-action-btn btn-submit"
                  onClick={handleCreatePost}
                  disabled={uploading}
                >
{uploading ? t("posting") : t("post")}                  
                </button>
              </div>
            </div>

            {filteredPosts.map((post) => (
              <div key={post.id} className="social-card">
                <div className="post-header">
                  <div className="post-user-info">
<img src={post.authorPhoto || post.userPhoto || profilePic} alt="" />                    
                    <div>
<div className="post-user-name">
  {post.authorName || post.userName}
  {post.authorRole === "driver" && (
    <span style={{ color: "#18508a", marginLeft: "6px", fontSize: "10px" }}>
      • Driver
    </span>
  )}
  {post.authorRole === "passenger" && (
    <span style={{ color: "#00a651", marginLeft: "6px", fontSize: "10px" }}>
      • Passenger
    </span>
  )}
</div>                      
                      <div className="post-time">{timeAgo(post.timestamp)}</div>
                    </div>
                  </div>
                </div>

                {post.text && <div className="post-text">{post.text}</div>}

                {post.mediaUrl && post.mediaType === 'image' && (
                  <img src={post.mediaUrl} className="post-single-image" alt="" />
                )}

                {post.mediaUrl && post.mediaType === 'video' && (
                  <video src={post.mediaUrl} controls className="post-single-image" />
                )}

<div style={{ marginTop: "10px" }}>
  {post.comments &&
    Object.entries(post.comments)
      .sort((a, b) => (a[1].timestamp || 0) - (b[1].timestamp || 0))
      .map(([commentId, comment]) => {
        const replies = comment.replies
          ? Object.entries(comment.replies).sort(
              (a, b) => (a[1].timestamp || 0) - (b[1].timestamp || 0)
            )
          : [];

        const commentReaction =
          comment.reactions && currentUser
            ? comment.reactions[currentUser.uid]?.value
            : null;

        const commentReactionCount = comment.reactions
          ? Object.keys(comment.reactions).length
          : 0;

        return (
          <div
            key={commentId}
            style={{
              marginBottom: "10px",
              padding: "8px",
              background: "#f7f7f7",
              borderRadius: "8px",
            }}
          >
            <div style={{ display: "flex", gap: "8px" }}>
              <img
                src={comment.userPhoto || "/default-avatar.png"}
                alt=""
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "11px", fontWeight: "bold" }}>
                  {comment.userName || "User"}
                  {comment.role === "driver" && (
                    <span style={{ color: "#18508a", marginLeft: "6px", fontSize: "10px" }}>
                      • Driver
                    </span>
                  )}
                </div>

                <div style={{ fontSize: "12px", color: "#444", marginTop: "2px" }}>
                  {comment.text}
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    flexWrap: "wrap",
                    marginTop: "6px",
                  }}
                >
                  {["❤️", "👍", "🔥", "😂", "👏"].map((emoji) => (
                    <button
                      key={emoji}
                      onClick={() => handleReactToComment(post.id, commentId, emoji)}
                      style={{
                        border:
                          commentReaction === emoji
                            ? "2px solid #18508a"
                            : "1px solid #ddd",
                        background: "#fff",

                        borderRadius: "20px",
                        padding: "2px 7px",
                        cursor: "pointer",
                        fontSize: "12px",
                      }}
                    >
                      {emoji}
                    </button>
                  ))}
                </div>

                <div
                  style={{
                    marginTop: "4px",
                    fontSize: "11px",
                    color: "#666",
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <span>{commentReactionCount} reactions</span>
                  <span>{timeAgo(comment.timestamp)}</span>
                </div>

                {replies.length > 0 && (
                  <div style={{ marginTop: "8px", paddingLeft: "8px" }}>
                 {replies.map(([replyId, reply]) => {
  const replyReaction =
    reply.reactions && currentUser
      ? reply.reactions[currentUser.uid]?.value
      : null;

  const replyReactionCount = reply.reactions
    ? Object.keys(reply.reactions).length
    : 0;

  return (
    <div
      key={replyId}
      style={{
        display: "flex",
        gap: "8px",
        marginBottom: "6px",
        background: "#fff",
        padding: "6px",
        borderRadius: "8px",
      }}
    >
      <img
        src={reply.userPhoto || "/default-avatar.png"}
        alt=""
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />

      <div style={{ flex: 1 }}>
        {/* Name + Role */}
        <div style={{ fontSize: "10px", fontWeight: "bold" }}>
          {reply.userName || "User"}

          {reply.role === "passenger" && (
            <span style={{ color: "#00a651", marginLeft: "6px", fontSize: "9px" }}>
              • Passenger
            </span>
          )}

          {reply.role === "driver" && (
            <span style={{ color: "#18508a", marginLeft: "6px", fontSize: "9px" }}>
              • Driver
            </span>
          )}
        </div>

        {/* Text */}
        <div style={{ fontSize: "11px", color: "#444" }}>
          {reply.text}
        </div>

        {/* 🔥 Emoji reactions */}
        <div style={{ display: "flex", gap: "4px", marginTop: "4px" }}>
          {["❤️", "👍", "🔥", "😂", "👏"].map((emoji) => (
            <button
              key={emoji}
              onClick={() =>
                handleReactToReply(post.id, commentId, replyId, emoji)
              }
              style={{
                border:
                  replyReaction === emoji
                    ? "2px solid #18508a"
                    : "1px solid #ddd",
                background: "#fff",
                borderRadius: "20px",
                padding: "2px 6px",
                cursor: "pointer",
                fontSize: "10px",
                transition: "0.2s",
              }}
            >
              {emoji}
            </button>
          ))}
        </div>

        {/* 🔥 Reaction count + time */}
        <div
          style={{
            fontSize: "10px",
            color: "#666",
            marginTop: "2px",
            display: "flex",
            gap: "6px",
            alignItems: "center",
          }}
        >
          {replyReactionCount > 0 && (
            <span>{replyReactionCount} reactions</span>
          )}
          <span>{timeAgo(reply.timestamp)}</span>
        </div>
      </div>
    </div>
  );
})}
                  </div>
                )}

                <div style={{ display: "flex", gap: "6px", marginTop: "8px" }}>
                  <input
                    type="text"
placeholder={t("reply_comment")}
                    value={replyInputs[`${post.id}_${commentId}`] || ""}
                    onChange={(e) =>
                      setReplyInputs((prev) => ({
                        ...prev,
                        [`${post.id}_${commentId}`]: e.target.value,
                      }))
                    }
                    style={{
                      flex: 1,
                      padding: "8px",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                      fontSize: "11px",
                    }}
                  />
                  <button
                    onClick={() => handleAddReply(post.id, commentId)}
                    style={{
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "8px",
                      background: "#18508a",
                      color: "#fff",
                      cursor: "pointer",
                      fontSize: "11px",
                      fontWeight: "bold",
                    }}
                  >
{t("reply")}                    
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}

  <div style={{ display: "flex", gap: "8px", marginTop: "8px" }}>
    <input
      type="text"
placeholder={t("write_comment")}      
      value={commentInputs[post.id] || ""}
      onChange={(e) =>
        setCommentInputs((prev) => ({
          ...prev,
          [post.id]: e.target.value,
        }))
      }
      style={{
        flex: 1,
        padding: "10px",
        borderRadius: "8px",
        border: "1px solid #ddd",
      }}
    />
    <button
      onClick={() => handleAddComment(post.id)}
      style={{
        border: "none",
        padding: "10px 14px",
        borderRadius: "8px",
        background: "#18508a",
        color: "#fff",
        cursor: "pointer",
      }}
    >
{t("send")}      
    </button>
  </div>
</div>

                <div className="post-footer">
                  <div
                    className="footer-btn"
                    onClick={() => handleToggleLike(post.id, post.likes)}
                  >
                    {post.likes && currentUser && post.likes[currentUser.uid] ? '❤️' : '🤍'}{" "}
                    {post.likes ? Object.keys(post.likes).length : 0}
                  </div>

                  <div className="footer-btn" onClick={() => handleSharePost(post)}>
                    <FaShare /> {t("share")}
                  </div>
                </div>
              </div>
            ))}
          </>
        )}

{activeView === 'wallet' && (
  <>
    <div className="social-card">
<div
  style={{
    background: "linear-gradient(135deg,#18508a,#00a651)",
    borderRadius: "24px",
    padding: "22px",
color: "#fff",    
    marginBottom: "15px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.18)",
    position: "relative",
    overflow: "hidden"
  }}
>
  {/* Background Circle */}
  <div
    style={{
      position: "absolute",
      top: "-50px",
      right: "-50px",
      width: "150px",
      height: "150px",
      background: "rgba(255,255,255,0.08)",
      borderRadius: "50%"
    }}
  />

  {/* Wallet Label */}
  <div
    style={{
      fontSize: "12px",
      opacity: 0.9,
      letterSpacing: "0.5px"
    }}
  >
<h3>{t("wallet_balance")}</h3>    
  </div>

  {/* Main Balance */}
  <div
    style={{
      fontSize: "38px",
      fontWeight: "bold",
      marginTop: "10px",
      letterSpacing: "1px"
    }}
  >
{formatCurrency(availableBalance, userCountry)}    
  </div>

  {/* Pending + Status */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "20px"
    }}
  >
    <div>
      <div
        style={{
          fontSize: "11px",
          opacity: 0.85
        }}
      >
{t("pending_withdrawals")}        
      </div>

      <div
        style={{
          fontWeight: "bold",
          marginTop: "4px",
          fontSize: "15px"
        }}
      >
{formatCurrency(pendingWithdrawalTotal, userCountry)}        
      </div>
    </div>

    <div
      style={{
        background: canWithdraw
          ? "rgba(0,255,140,0.18)"
          : "rgba(255,255,255,0.15)",
        padding: "9px 15px",
        borderRadius: "999px",
        fontWeight: "bold",
        fontSize: "11px",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.12)"
      }}
    >
{canWithdraw ? `✅ ${t("ready")}` : `🔒 ${t("locked")}`}      
    </div>
  </div>

  {/* Progress */}
  <div
    style={{
      marginTop: "18px"
    }}
  >
    <div
      style={{
        height: "10px",
        background: "rgba(255,255,255,0.2)",
        borderRadius: "999px",
        overflow: "hidden"
      }}
    >
      <div
        style={{
          width: `${Math.min((availableBalance / 100) * 100, 100)}%`,
          height: "100%",
          background: "#fff",
          transition: "0.4s"
        }}
      />
    </div>

    <div
      style={{
        marginTop: "8px",
        fontSize: "11px",
        opacity: 0.9
      }}
    >
    {canWithdraw
  ? t("withdrawal_unlocked")
: `${formatCurrency(amountLeftToWithdraw, userCountry)} ${t("needed_unlock")}`  
}

    </div>
  </div>
</div>

</div>

<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    marginBottom: "15px",
  }}
>
  <div
    style={{
      background: "#fff",
      padding: "15px",
      borderRadius: "18px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    }}
  >
    <div style={{ fontSize: "11px", color: "#777" }}>{t("total_spent")}</div>
    <div style={{ fontSize: "20px", fontWeight: "bold", color: "#18508a" }}>
{formatCurrency(totalSpend, userCountry)}      
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "15px",
      borderRadius: "18px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    }}
  >
    <div style={{ fontSize: "11px", color: "#777" }}>{t("total_saved")}</div>
    <div style={{ fontSize: "20px", fontWeight: "bold", color: "#00a651" }}>
{formatCurrency(totalSavings, userCountry)}      
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "15px",
      borderRadius: "18px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    }}
  >
    <div style={{ fontSize: "11px", color: "#777" }}>{t("withdrawn")}</div>
    <div style={{ fontSize: "20px", fontWeight: "bold", color: "#9b359e" }}>
{formatCurrency(Number(walletData.totalWithdrawn || 0), userCountry)}      
    </div>
  </div>

  <div
    style={{
      background: "#fff",
      padding: "15px",
      borderRadius: "18px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
    }}
  >
<div style={{ fontSize: "11px", color: "#777" }}>
  {t("status")}
</div>    
    <div
      style={{
        fontSize: "16px",
        fontWeight: "bold",
        color: canWithdraw ? "#00c853" : "#ff416c",
      }}
    >
{canWithdraw ? t("unlocked") : t("locked")}      
    </div>
  </div>
</div>

<div
  style={{
    background: "linear-gradient(135deg,#ffffff,#f7fbff)",
    borderRadius: "22px",
    padding: "20px",
    boxShadow: "0 10px 30px rgba(24,80,138,0.10)",
    border: "1px solid rgba(24,80,138,0.08)",
    marginBottom: "15px",
    position: "relative",
    overflow: "hidden",
  }}
>

  <h3
    style={{
      marginBottom: "15px",
      color: "#18508a",
      fontSize: "17px",
      fontWeight: "800",
    }}
  >
{t("request_withdrawal")}    
  </h3>

  <select
  value={withdrawMethod}
  onChange={(e) => setWithdrawMethod(e.target.value)}
  style={{
    width: "100%",
    padding: "12px",
    borderRadius: "16px",
background: "#f9fbff",
fontSize: "13px",
outline: "none",

    border: "1px solid #ddd",
    marginBottom: "10px",
  }}
>
  <option value="Flutterwave">Flutterwave</option>
  <option value="PayPal">PayPal</option>
  <option value="Stripe">Stripe</option>
  <option value="Xendit">Xendit</option>
</select>

  <input
    type="text"
placeholder={
  withdrawMethod === "PayPal"
    ? "PayPal Email"
    : withdrawMethod === "Flutterwave"
    ? "Flutterwave Account"
    : withdrawMethod === "Stripe"
    ? "Stripe Account"
    : "Xendit Account"
}
    value={accountNumber}
    onChange={(e) => setAccountNumber(e.target.value)}
    style={{
      width: "100%",
      padding: "12px",
      borderRadius: "12px",
      border: "1px solid #ddd",
      marginBottom: "10px",
    }}
  />

  <input
    type="number"
placeholder={t("enter_amount")}    
    value={withdrawAmount}
    onChange={(e) => setWithdrawAmount(e.target.value)}
    style={{
      width: "100%",
      padding: "12px",
      borderRadius: "12px",
      border: "1px solid #ddd",
      marginBottom: "15px",
    }}
  />

  <button
    onClick={handleWithdrawRequest}
    disabled={!canWithdraw || withdrawing}
    style={{
      width: "100%",
      padding: "14px",
      border: "none",
      borderRadius: "18px",
background: canWithdraw
  ? "linear-gradient(135deg,#18508a,#00a651)"
  : "#999",

      color: "#fff",
      fontWeight: "bold",
      cursor: canWithdraw ? "pointer" : "not-allowed",
      fontSize: "14px",
    }}
  >
{withdrawing ? t("processing") : t("request_withdrawal")}    
  </button>
</div>

<div
  style={{
    background: "linear-gradient(135deg,#18508a,#00a651)",
    borderRadius: "20px",

    padding: "18px",
    boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
  }}
>
 <h3
  style={{
    marginBottom: "15px",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "bold",
  }}
>
{t("wallet_transactions")}    
  </h3>

  {walletTransactions.length === 0 ? (
    <div style={{ color: "#888", fontSize: "12px" }}>
{t("no_transactions")}      
    </div>
  ) : (

   walletTransactions.map((tx) => {
  const ride = myRides.find((r) => r.id === tx.rideId);

  return (
    <div
      key={tx.id}
      className="wallet-transaction-card"
      onClick={() => {
        if (ride) {
          setSelectedWalletRide(ride);
        }
      }}
      style={{
        background: "#fff",
      borderRadius: "8px",
padding: "5px 7px",
marginBottom: "5px",

        boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
        cursor: "pointer",
        transition: "0.2s",
        border: "1px solid #f1f1f1",

        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: "11px",
          }}
        >
          {tx.type === "withdrawal"
            ? t("withdrawal_request")
            : t("ride_savings")}
        </div>

        <div
          style={{
            fontSize: "9px",
            color: "#777",
          }}
        >
          {new Date(tx.createdAt).toLocaleString()}
        </div>
      </div>

      <div style={{ textAlign: "right" }}>
        <div
          style={{
            fontWeight: "bold",
            color:
              tx.type === "withdrawal"
                ? "#ff416c"
                : "#00a651",
          }}
        >
          {tx.type === "withdrawal" ? "-" : "+"}
          {formatCurrency(Number(tx.amount), userCountry)}
        </div>

              <div
          style={{
            fontSize: "8px",
            color:
              tx.status === "completed"
                ? "#00c853"
                : "#ff9800",
          }}
        >
          {tx.status}
        </div>
      </div>
    </div>
  );
})
)}
</div>

{selectedWalletRide && (
  <div
    style={{
      background: "#eceeec",
      borderRadius: "10px",
      padding: "8px",
      marginTop: "6px",
      boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
      border:
        selectedWalletRide.status === "completed" ||
        selectedWalletRide.tripEnded
          ? "2px solid #00c853"
          : "2px solid #ff416c",

      position: "relative",

      width: "100%",
      maxWidth: "100%",
      overflow: "hidden",

      display: "flex",
      flexDirection: "column",
      gap: "10px",
    }}
  >
    <FaTimes
      onClick={() => setSelectedWalletRide(null)}
      style={{
        position: "absolute",
        right: "10px",
        top: "10px",
        cursor: "pointer",
        color: "#777",
        fontSize: "13px",
      }}
    />

    <h3
      style={{
        color: "#18508a",
        marginBottom: "6px",
        fontSize: "15px",
        lineHeight: "1.2",
        paddingRight: "25px",
        wordBreak: "break-word",
      }}
    >
      {selectedWalletRide.city || "Abuja"}
    </h3>

    <div
      style={{
        fontSize: "11px",
        color: "#777",
        marginBottom: "4px",
      }}
    >
      📍 {selectedWalletRide.distanceKm || ""} km
    </div>

    <div
      style={{
        fontWeight: "bold",
        fontSize: "16px",
        color: "#00a651",
        marginBottom: "10px",
      }}
    >
      {formatCurrency(
        Number(selectedWalletRide.fare || 0),
        userCountry
      )}
    </div>

    <div
      style={{
        fontSize: "11px",
        marginBottom: "6px",
        color: "#333",
        lineHeight: "1.4",
        wordBreak: "break-word",
      }}
    >
      <b>Pickup:</b>{" "}
      {selectedWalletRide.pickupAddress ||
        selectedWalletRide.pickup?.address ||
        "Unknown"}
    </div>

    <div
      style={{
        fontSize: "11px",
        marginBottom: "10px",
        color: "#333",
        lineHeight: "1.4",
        wordBreak: "break-word",
      }}
    >
      <b>Drop-off:</b>{" "}
      {selectedWalletRide.dropoffAddress ||
        selectedWalletRide.destinationCoords?.address ||
        "Unknown"}
    </div>

    <div
      style={{
        display: "flex",
        gap: "8px",
        width: "100%",
      }}
    >
      <button
        onClick={() =>
          window.open(
            `tel:${selectedWalletRide.driverPhone || ""}`
          )
        }
        style={{
          flex: 1,
          border: "none",
          padding: "10px",
          borderRadius: "10px",
          background: "#18508a",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "12px",
          cursor: "pointer",
          minWidth: 0,
        }}
      >
        Call
      </button>

      <button
        onClick={() =>
          window.open(
            `https://wa.me/${
              selectedWalletRide.driverPhone?.replace(
                /\D/g,
                ""
              ) || ""
            }`
          )
        }
        style={{
          flex: 1,
          border: "none",
          padding: "10px",
          borderRadius: "10px",
          background: "#00a651",
          color: "#fff",
          fontWeight: "bold",
          fontSize: "12px",
          cursor: "pointer",
          minWidth: 0,
        }}
      >
        Chat
      </button>
    </div>
  </div>
)}

</>
)}

        {activeView === 'history' && (
          <>

<div className="social-card">

        {showGraphDetails && (
  <div className="social-card">

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "12px",
      }}
    >
      <h3
        style={{
          color: "#18508a",
          fontSize: "14px",
        }}
      >
        Ride Details
      </h3>

      <FaTimes
        style={{
          cursor: "pointer",
        }}
        onClick={() =>
          setShowGraphDetails(false)
        }
      />
    </div>

    {selectedGraphRides.map((ride) => (
      <div
        key={ride.id}
        style={{
background:
  "linear-gradient(180deg,#18508a,#00a651)",          
          borderRadius: "14px",
          padding: "10px",
color: "#fff",          
border: "1px solid rgba(255,255,255,0.12)",
          marginBottom: "8px",
          boxShadow:
  "0 8px 20px rgba(24,80,138,0.18)",

        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: "13px",
          }}
        >
          {ride.driverName}
        </div>

        <div
          style={{
            fontSize: "10px",
color: "rgba(255,255,255,0.85)",            
          }}
        >
          {formatDisplayDate(
            ride.date || ride.timestamp
          )}
        </div>

        <div
          style={{
            marginTop: "6px",
color: "#ca1609",            
            fontWeight: "bold",
          }}
        >
          {formatCurrency(
            Number(ride.fare || 0),
            userCountry
          )}
        </div>

        <div
          style={{
            marginTop: "4px",
            fontSize: "10px",
color: "rgba(7, 7, 7, 0.92)",          
          }}
        >
          📍 {ride.pickupAddress}
        </div>

        <div
          style={{
            marginTop: "2px",
            fontSize: "10px",
color: "rgba(7, 7, 7, 0.92)",            
          }}
        >
          🏁 {ride.dropoffAddress}
        </div>
      </div>
    ))}
  </div>
)}



  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "15px",
    }}
  >
    <h3
      style={{
        fontSize: "14px",
        color: "#18508a",
        display: "flex",
        alignItems: "center",
        gap: "6px",
      }}
    >
      <FaChartBar /> Ride Analytics
    </h3>

    <select
      value={historyPeriod}
      onChange={(e) =>
        setHistoryPeriod(e.target.value)
      }
      style={{
        padding: "6px 10px",
        borderRadius: "10px",
        border: "1px solid #ddd",
        fontSize: "11px",
      }}
    >
      <option value="daily">Daily</option>
      <option value="weekly">Weekly</option>
      <option value="monthly">Monthly</option>
      <option value="yearly">Yearly</option>
    </select>
  </div>

  <div
    style={{
      display: "flex",
      alignItems: "flex-end",
      gap: "10px",
      height: "180px",
      overflowX: "auto",
      paddingBottom: "10px",
    }}
  >
    {historyGraphData.map((item, idx) => {

      const height =
        (item.total / maxGraphValue) * 140;

      return (
        <div
          key={idx}
          onClick={() => {
            setSelectedGraphRides(item.rides);
            setShowGraphDetails(true);
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            cursor: "pointer",
            minWidth: "55px",
          }}
        >
          <div
            style={{
              fontSize: "10px",
              marginBottom: "6px",
              color: "#18508a",
              fontWeight: "bold",
            }}
          >
            {formatCurrency(item.total, userCountry)}
          </div>

          <div
            style={{
              width: "36px",
              height: `${height}px`,
              borderRadius: "14px",
              background:
                "linear-gradient(180deg,#18508a,#00a651)",
              transition: "0.3s",
              boxShadow:
                "0 6px 18px rgba(0,0,0,0.12)",
            }}
          />

          <div
            style={{
              fontSize: "10px",
              marginTop: "8px",
              textAlign: "center",
              color: "#666",
            }}
          >
            {item.label}
          </div>
        </div>
      );
    })}
  </div>
</div>

<div className="social-card">
  <h3
    style={{
      fontSize: '13px',
      color: '#18508a',
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      gap: '5px'
    }}
  >
    <FaChartBar /> {t("weekly_spending")}
  </h3>

  {weeklyBreakdown.map((item, idx) => (
    <div
      key={idx}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 0',
        borderBottom:
          idx !== weeklyBreakdown.length - 1
            ? '1px solid #f0f0f0'
            : 'none',
        fontSize: '12px'
      }}
    >
      <div>
        <div
          style={{
            fontWeight: 'bold',
            color: '#333'
          }}
        >
          {item.day}
        </div>

        <div
          style={{
            fontSize: '10px',
            color: '#aaa'
          }}
        >
          {item.date}
        </div>
      </div>

      <div style={{ textAlign: 'right' }}>
        <div
          style={{
            fontWeight: 'bold',
            color:
              item.amount > 0
                ? '#ff416c'
                : '#ccc'
          }}
        >
          {formatCurrency(item.amount, userCountry)}
        </div>

        <div
          style={{
            fontSize: '9px',
            color: '#00c853'
          }}
        >
          {t("saved")}{" "}
          {formatCurrency(item.savings, userCountry)}
        </div>
      </div>
    </div>
  ))}

  <div
    style={{
      marginTop: '10px',
      paddingTop: '10px',
      borderTop: '2px solid #f0f0f0',
      display: 'flex',
      justifyContent: 'space-between'
    }}
  >
    <span
      style={{
        fontWeight: 'bold',
        fontSize: '13px'
      }}
    >
      {t("total_spent")}
    </span>

    <span
      style={{
        fontWeight: 'bold',
        fontSize: '13px',
        color: '#18508a'
      }}
    >
      {formatCurrency(totalSpend, userCountry)}
    </span>
  </div>
</div>








            <div className="social-card">
              <h3 style={{ fontSize: '11px', color: '#888', textTransform: 'uppercase', marginBottom: '8px' }}>
{t("ride_log")}                
              </h3>

              {myRides.length === 0 ? (
                <p style={{ textAlign: 'center', fontSize: '11px', color: '#ccc' }}>{t("no_rides")}</p>
              ) : (
                myRides.map((ride) => (
                  <div
  key={ride.id}
  className="ride-history-card"
                    style={{
                      background: '#8a2697',
                      padding: '10px 0',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '8px',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                  >
                    <img
                      src={ride.driverPhoto}
                      style={{ width: 35, height: 35, borderRadius: '50%' }}
                      alt=""
                    />

                    <div style={{ flex: 1, marginLeft: '10px' }}>
                      <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{ride.driverName}</div>
                      <div style={{ fontSize: '10px', color: '#888' }}>
                        {formatDisplayDate(ride.date || ride.timestamp)}
                      </div>
                    </div>

                    <div style={{ textAlign: 'right' }}>
                      <div style={{ color: '#00c853', fontWeight: 'bold', fontSize: '14px' }}>
{formatCurrency(Number(ride.fare || 0), userCountry)}

                      </div>
                      <div style={{ fontSize: '9px', color: '#18508a' }}>
{t("saved")} {formatCurrency((Number(ride.fare || 0) * 0.1), userCountry)}                        
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </>
        )}
      </div>

      <div className="social-bottom-nav">
        <FaHome
          className={`bottom-nav-icon ${activeView === 'feed' ? 'active' : ''}`}
          onClick={() => setActiveView('feed')}
        />

        <FaHistory
          className={`bottom-nav-icon ${activeView === 'history' ? 'active' : ''}`}
          onClick={() => setActiveView('history')}
        />

        <div className="fab-button" onClick={handleImagePick}>
          +
        </div>

        <BsFillPlayCircleFill
          className={`bottom-nav-icon ${activeView === 'reels' ? 'active' : ''}`}
          onClick={() => setActiveView('reels')}
        />

        <FaUser className="bottom-nav-icon" onClick={onClose} />
      </div>
    </div>
  );
};

export default PassengerSocialProfile;



